var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGuideIcon = function SvgGuideIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4D5B5A",
    clipPath: "url(#guide-icon_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.792 16.033 17.808 12.7a.34.34 0 0 1 0-.283c.087-.203.132-.421.134-.642V3.442a1.667 1.667 0 0 0-1.667-1.667H3.75a1.667 1.667 0 0 0-1.667 1.667v8.333c.002.22.047.439.134.642a.34.34 0 0 1 0 .283L.233 16.033A1.42 1.42 0 0 0 .192 17.5a1.48 1.48 0 0 0 1.283.75h17.05a1.48 1.48 0 0 0 1.283-.75 1.42 1.42 0 0 0-.016-1.467m-7.709.534H7.917a.625.625 0 0 1 0-1.25h4.166a.625.625 0 1 1 0 1.25m4.042-4.9a.43.43 0 0 1-.292.125H4.167a.426.426 0 0 1-.417-.417v-7.5a.417.417 0 0 1 .417-.417h11.666a.417.417 0 0 1 .417.417v7.5a.4.4 0 0 1-.125.292"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.95 8.242-1.75.583a.66.66 0 0 1-.4 0l-1.75-.583a.4.4 0 0 0-.502.2.4.4 0 0 0-.048.191v.7a.83.83 0 0 0 .558.784l1.525.541c.27.1.565.1.834 0l1.525-.541a.83.83 0 0 0 .558-.784v-.7a.43.43 0 0 0-.175-.341.4.4 0 0 0-.375-.05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m13.883 5.958-3.75-1.25a.5.5 0 0 0-.266 0l-3.75 1.25a.425.425 0 0 0-.284.4v2.084a.417.417 0 1 0 .834 0V7.225a.23.23 0 0 1 .083-.175.23.23 0 0 1 .192 0L9.867 8a.37.37 0 0 0 .266 0l3.75-1.25a.416.416 0 0 0 0-.792"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "guide-icon_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export { SvgGuideIcon as ReactComponent };